var _style, _defs, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g, _defs2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle2, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle3, _path55, _path56, _path57, _ellipse, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _polygon, _polygon2, _path68, _path69, _path70, _path71, _path72, _polygon3, _polygon4, _path73, _path74, _path75, _polygon5, _polygon6, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path91, _rect22, _path92, _path93, _polygon7, _polygon8, _polygon9, _polygon10, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path94, _path95, _path96, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _rect29, _rect30, _path97, _rect31, _polygon16, _polygon17, _path98, _polygon18, _polygon19, _polygon20, _polygon21, _g2, _path99, _path100, _path101, _path102, _path103, _path104, _rect32, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _rect33, _path116, _path117, _path118, _polygon22, _path119, _rect34, _path120, _rect35, _rect36, _path121, _circle4, _path122, _circle5, _path123, _path124, _path125, _rect37, _path126, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_5_);}\r\n\t.st3{fill:url(#SVGID_6_);}\r\n\t.st4{fill:url(#SVGID_7_);}\r\n\t.st5{fill:url(#SVGID_8_);}\r\n\t.st6{fill:url(#SVGID_9_);}\r\n\t.st7{fill:url(#SVGID_10_);}\r\n\t.st8{fill:url(#SVGID_11_);}\r\n\t.st9{fill:url(#SVGID_12_);}\r\n\t.st10{fill:url(#SVGID_13_);}\r\n\t.st11{fill:url(#SVGID_14_);}\r\n\t.st12{fill:url(#SVGID_15_);}\r\n\t.st13{fill:url(#SVGID_16_);}\r\n\t.st14{fill:url(#SVGID_17_);}\r\n\t.st15{fill:url(#SVGID_18_);}\r\n\t.st16{fill:url(#SVGID_19_);}\r\n\t.st17{fill:url(#SVGID_20_);}\r\n\t.st18{fill:#02247D;}\r\n\t.st19{fill:#00FFFF;}\r\n\t.st20{fill:none;}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:#00D0FF;}\r\n\t.st33{fill:url(#SVGID_33_);}\r\n\t.st34{fill:url(#SVGID_34_);}\r\n\t.st35{fill:url(#SVGID_35_);}\r\n\t.st36{fill:url(#SVGID_36_);}\r\n\t.st37{fill:#E5E9FF;}\r\n\t.st38{fill:url(#SVGID_37_);}\r\n\t.st39{fill:url(#SVGID_38_);}\r\n\t.st40{fill:url(#SVGID_39_);}\r\n\t.st41{fill:url(#SVGID_40_);}\r\n\t.st42{fill:url(#SVGID_41_);}\r\n\t.st43{fill:url(#SVGID_42_);}\r\n\t.st44{fill:url(#SVGID_43_);}\r\n\t.st45{fill:url(#SVGID_44_);}\r\n\t.st46{fill:url(#SVGID_45_);}\r\n\t.st47{fill:url(#SVGID_46_);}\r\n\t.st48{fill:url(#SVGID_47_);}\r\n\t.st49{fill:url(#SVGID_48_);}\r\n\t.st50{fill:url(#SVGID_49_);}\r\n\t.st51{fill:url(#SVGID_50_);}\r\n\t.st52{fill:url(#SVGID_51_);}\r\n\t.st53{fill:url(#SVGID_52_);}\r\n\t.st54{fill:url(#SVGID_53_);}\r\n\t.st55{fill:url(#SVGID_54_);}\r\n\t.st56{fill:url(#SVGID_55_);}\r\n\t.st57{fill:url(#SVGID_56_);}\r\n\t.st58{fill:url(#SVGID_57_);}\r\n\t.st59{fill:url(#SVGID_58_);}\r\n\t.st60{fill:url(#SVGID_59_);}\r\n\t.st61{fill:url(#SVGID_60_);}\r\n\t.st62{fill:url(#SVGID_61_);}\r\n\t.st63{fill:url(#SVGID_62_);}\r\n\t.st64{fill:url(#SVGID_63_);}\r\n\t.st65{fill:url(#SVGID_64_);}\r\n\t.st66{fill:url(#SVGID_65_);}\r\n\t.st67{fill:url(#SVGID_66_);}\r\n\t.st68{fill:url(#SVGID_67_);}\r\n\t.st69{fill:url(#SVGID_68_);}\r\n\t.st70{fill:url(#SVGID_69_);}\r\n\t.st71{fill:url(#SVGID_70_);}\r\n\t.st72{fill:url(#SVGID_71_);}\r\n\t.st73{fill:url(#SVGID_72_);}\r\n\t.st74{fill:url(#SVGID_73_);}\r\n\t.st75{fill:url(#SVGID_74_);}\r\n\t.st76{fill:url(#SVGID_75_);}\r\n\t.st77{fill:url(#SVGID_76_);}\r\n\t.st78{fill:url(#SVGID_77_);}\r\n\t.st79{fill:url(#SVGID_78_);}\r\n\t.st80{fill:url(#SVGID_79_);}\r\n\t.st81{fill:url(#SVGID_80_);}\r\n\t.st82{fill:url(#SVGID_81_);}\r\n\t.st83{fill:url(#SVGID_82_);}\r\n\t.st84{fill:url(#SVGID_83_);}\r\n\t.st85{fill:url(#SVGID_84_);}\r\n\t.st86{fill:url(#SVGID_85_);}\r\n\t.st87{fill:url(#SVGID_86_);}\r\n\t.st88{fill-rule:evenodd;clip-rule:evenodd;fill:#02247D;}\r\n\t.st89{fill:url(#SVGID_87_);}\r\n\t.st90{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_88_);}\r\n\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_89_);}\r\n\t.st92{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_90_);}\r\n\t.st93{fill:url(#SVGID_91_);}\r\n\t.st94{fill:url(#SVGID_92_);}\r\n\t.st95{fill:url(#SVGID_93_);}\r\n\t.st96{fill:url(#SVGID_94_);}\r\n\t.st97{fill:url(#SVGID_95_);}\r\n\t.st98{fill:url(#SVGID_96_);}\r\n\t.st99{fill:url(#SVGID_97_);}\r\n\t.st100{fill:url(#SVGID_98_);}\r\n\t.st101{fill:url(#SVGID_99_);}\r\n\t.st102{fill:url(#SVGID_100_);}\r\n\t.st103{fill:url(#SVGID_101_);}\r\n\t.st104{fill:url(#SVGID_102_);}\r\n\t.st105{fill:url(#SVGID_103_);}\r\n\t.st106{fill:url(#SVGID_104_);}\r\n\t.st107{fill:url(#SVGID_105_);}\r\n\t.st108{fill:url(#SVGID_106_);}\r\n\t.st109{fill:url(#SVGID_107_);}\r\n\t.st110{fill:url(#SVGID_108_);}\r\n\t.st111{fill:url(#SVGID_109_);}\r\n\t.st112{fill:url(#SVGID_110_);}\r\n\t.st113{fill:url(#SVGID_111_);}\r\n\t.st114{fill:url(#SVGID_112_);}\r\n\t.st115{fill:url(#SVGID_113_);}\r\n\t.st116{fill:url(#SVGID_114_);}\r\n\t.st117{fill:url(#SVGID_115_);}\r\n\t.st118{fill:url(#SVGID_116_);}\r\n\t.st119{fill:url(#SVGID_117_);}\r\n\t.st120{fill:url(#SVGID_118_);}\r\n\t.st121{fill:url(#SVGID_119_);}\r\n\t.st122{fill:url(#SVGID_120_);}\r\n\t.st123{fill:url(#SVGID_121_);}\r\n\t.st124{fill:url(#SVGID_122_);}\r\n\t.st125{fill:url(#SVGID_123_);}\r\n\t.st126{fill:url(#SVGID_124_);}\r\n\t.st127{fill:url(#SVGID_125_);}\r\n\t.st128{fill:url(#SVGID_126_);}\r\n\t.st129{fill:url(#SVGID_127_);}\r\n\t.st130{fill:url(#SVGID_128_);}\r\n\t.st131{fill:url(#SVGID_129_);}\r\n\t.st132{fill:url(#SVGID_130_);}\r\n\t.st133{fill:url(#SVGID_131_);}\r\n\t.st134{fill:url(#SVGID_132_);}\r\n\t.st135{fill:url(#SVGID_133_);}\r\n\t.st136{fill:url(#SVGID_134_);}\r\n\t.st137{fill:url(#SVGID_135_);}\r\n\t.st138{fill:url(#SVGID_136_);}\r\n\t.st139{fill:url(#SVGID_137_);}\r\n\t.st140{fill:url(#SVGID_138_);}\r\n\t.st141{fill:url(#SVGID_139_);}\r\n\t.st142{fill:#2143AF;}\r\n\t.st143{fill:url(#SVGID_140_);}\r\n\t.st144{fill:url(#SVGID_141_);}\r\n\t.st145{fill:url(#SVGID_142_);}\r\n\t.st146{fill:url(#SVGID_143_);}\r\n\t.st147{fill:url(#SVGID_144_);}\r\n\t.st148{fill:url(#SVGID_145_);}\r\n\t.st149{fill:url(#SVGID_146_);}\r\n\t.st150{fill:url(#SVGID_147_);}\r\n\t.st151{fill:url(#SVGID_148_);}\r\n\t.st152{fill:url(#SVGID_149_);}\r\n\t.st153{fill:url(#SVGID_150_);}\r\n\t.st154{fill:url(#SVGID_151_);}\r\n\t.st155{fill:url(#SVGID_152_);}\r\n\t.st156{fill:url(#SVGID_153_);}\r\n\t.st157{fill:url(#SVGID_154_);}\r\n\t.st158{fill:url(#SVGID_155_);}\r\n\t.st159{fill:url(#SVGID_156_);}\r\n\t.st160{opacity:0.4;fill:#E5E9FF;}\r\n\t.st161{fill:url(#SVGID_157_);}\r\n\t.st162{fill:url(#SVGID_158_);}\r\n\t.st163{fill:url(#SVGID_159_);}\r\n\t.st164{fill:url(#SVGID_160_);}\r\n\t.st165{fill:url(#SVGID_161_);}\r\n\t.st166{fill:url(#SVGID_162_);}\r\n\t.st167{fill:url(#SVGID_163_);}\r\n\t.st168{fill:url(#SVGID_164_);}\r\n\t.st169{fill:url(#SVGID_165_);}\r\n\t.st170{fill:#7D41DA;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 900,
    height: 600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.9996,
    y1: -74.9999,
    x2: 74.9999,
    y2: 674.9999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4738,
    style: {
      stopColor: "#3532B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    style: {
      stopColor: "#092998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1604.7114,
    y1: 1674.7275,
    x2: 2253.646,
    y2: 1674.7275,
    gradientTransform: "matrix(-1 0 0 -1 2305.6582 2137.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.95,510.1h617.06c8.8,0,15.94-7.13,15.94-15.94l0,0c0-8.8-7.13-15.94-15.94-15.94h-73.36 c-8.8,0-15.94-7.14-15.94-15.94l0,0c0-8.8,7.13-15.94,15.94-15.94h45.22c8.8,0,15.94-7.13,15.94-15.94v0 c0-8.8-7.13-15.94-15.94-15.94H78.18c-8.8,0-15.94,7.13-15.94,15.94v0c0,8.8,7.13,15.94,15.94,15.94h2.5 c8.8,0,15.94,7.13,15.94,15.94l0,0c0,8.8-7.13,15.94-15.94,15.94H67.95c-8.8,0-15.94,7.13-15.94,15.94l0,0 C52.01,502.97,59.15,510.1,67.95,510.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.4155,
    y1: 300.3897,
    x2: 545.1841,
    y2: 300.3897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M521.44,170.06c0.04,0.26,0.34,0.52,0.34,0.79v39.05c0,2.9-2.63,5.2-5.53,5.2l-23.95,0.05 c-2.9,0-5.29-2.3-5.29-5.2v-39.1c0-0.27-0.08-0.53-0.04-0.78c-14.1,6.16-23.55,19.66-23.55,35.34c0,15.44,10.78,31,23.59,38.53 v169.42c0,9.82,6.95,17.37,16.77,17.37h0.04c9.82,0,17.96-7.55,17.96-17.37V243.93c14.64-7.53,23.4-23.08,23.4-38.53 C545.18,189.73,535.54,176.22,521.44,170.06z M504.01,420.6c-3.8,0-6.88-3.08-6.88-6.88c0-3.8,3.08-6.88,6.88-6.88 c3.8,0,6.88,3.08,6.88,6.88C510.89,417.52,507.81,420.6,504.01,420.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.4155,
    y1: 300.0703,
    x2: 546.1841,
    y2: 300.0703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.82,431.72c-10.17,0-17.81-7.9-17.81-18.37V244.5c-13.92-8.41-23.59-24.4-23.59-39.09 c0-15.62,9.48-29.85,24.15-36.26l1.66-0.72l-0.27,1.79c0,0.06,0.01,0.13,0.02,0.19c0.02,0.15,0.03,0.29,0.03,0.44v39.1 c0,2.32,1.92,4.2,4.29,4.2l23.95-0.05c2.46,0,4.53-1.92,4.53-4.2v-38.91c-0.01-0.01-0.02-0.03-0.03-0.04 c-0.1-0.17-0.26-0.42-0.3-0.74l-0.26-1.79l1.65,0.72c14.79,6.46,24.34,20.69,24.34,36.26c0,16.26-9.17,31.55-23.4,39.13v168.81 C522.78,423.48,514.27,431.72,503.82,431.72z M486.01,171.6c-13.36,6.41-21.59,19.24-21.59,33.8c0,14.19,9.5,29.68,23.1,37.66 l0.49,0.29v169.99c0,9.49,6.63,16.37,15.77,16.37c9.55,0,17.01-7.19,17.01-16.37V243.32l0.54-0.28 c13.89-7.14,22.86-21.91,22.86-37.64c0-14.15-8.34-27.15-21.4-33.61v38.11c0,3.36-2.99,6.2-6.53,6.2l-23.95,0.05 c-3.47,0-6.29-2.78-6.29-6.2V171.6z M504.01,421.6L504.01,421.6c-4.35,0-7.88-3.54-7.88-7.88c0-4.35,3.54-7.88,7.88-7.88 c0,0,0,0,0,0c2.11,0,4.08,0.82,5.57,2.31c1.49,1.49,2.31,3.47,2.31,5.58c0,2.11-0.82,4.08-2.31,5.57 C508.1,420.78,506.12,421.6,504.01,421.6z M504.01,407.84C504.01,407.84,504.01,407.84,504.01,407.84 c-3.25,0-5.88,2.64-5.88,5.88c0,3.24,2.64,5.88,5.88,5.88c1.57,0,3.05-0.61,4.16-1.72c1.11-1.11,1.72-2.59,1.72-4.16 c0-1.57-0.61-3.05-1.72-4.16C507.06,408.45,505.58,407.84,504.01,407.84z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.5747,
    y1: 467.8506,
    x2: 259.772,
    y2: 467.8506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.57,
    y: 466.85,
    className: "st5",
    width: 88.2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.5356,
    y1: 455.8018,
    x2: 361.8838,
    y2: 455.8018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.54,
    y: 454.8,
    className: "st6",
    width: 195.35,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.4995,
    y1: 467.8506,
    x2: 322.4262,
    y2: 467.8506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 292.5,
    y: 466.85,
    className: "st7",
    width: 29.93,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.8447,
    y1: 467.8506,
    x2: 155.5781,
    y2: 467.8506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137.84,
    y: 466.85,
    className: "st8",
    width: 17.73,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.3335,
    y1: 476.7979,
    x2: 498.1011,
    y2: 476.7979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 446.33,
    y: 475.8,
    className: "st9",
    width: 51.77,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.6982,
    y1: 477.7979,
    x2: 385.2637,
    y2: 477.7979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 367.7,
    y: 476.8,
    className: "st10",
    width: 17.57,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.5356,
    y1: 476.7979,
    x2: 436.9448,
    y2: 476.7979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 426.54,
    y: 475.8,
    className: "st11",
    width: 10.41,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.5591,
    y1: 470.3438,
    x2: 567.7124,
    y2: 470.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 537.56,
    y: 469.34,
    className: "st12",
    width: 30.15,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 578.9009,
    y1: 470.3438,
    x2: 589.1313,
    y2: 470.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 578.9,
    y: 469.34,
    className: "st13",
    width: 10.23,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.0278,
    y1: 470.3438,
    x2: 532.0903,
    y2: 470.3438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 526.03,
    y: 469.34,
    className: "st14",
    width: 6.06,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.6821,
    y1: 462.1836,
    x2: 399.9238,
    y2: 462.1836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 381.68,
    y: 461.18,
    className: "st15",
    width: 18.24,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.5586,
    y1: 462.1836,
    x2: 416.4536,
    y2: 462.1836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 408.56,
    y: 461.18,
    className: "st16",
    width: 7.89,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.3608,
    y1: 488.5108,
    x2: 591.2134,
    y2: 488.5108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 539.36,
    y: 487.51,
    className: "st17",
    width: 51.85,
    height: 2
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168.21,
    y: 145.01,
    className: "st18",
    width: 7.96,
    height: 13.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M177.16,159.93h-9.96v-15.92h9.96V159.93z M169.21,157.93h5.96v-11.92h-5.96V157.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.39,
    y: 136.28,
    className: "st18",
    width: 7.96,
    height: 22.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M188.35,159.93h-9.96v-24.65h9.96V159.93z M180.39,157.93h5.96v-20.65h-5.96V157.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.58,
    y: 130.25,
    className: "st18",
    width: 7.96,
    height: 28.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M199.54,159.93h-9.96v-30.69h9.96V159.93z M191.58,157.93h5.96v-26.69h-5.96V157.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.77,
    y: 122.95,
    className: "st18",
    width: 7.96,
    height: 35.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M210.72,159.93h-9.96v-37.98h9.96V159.93z M202.77,157.93h5.96v-33.98h-5.96V157.93z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_339_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M467.34,96.26v323.19c0,9.81-7.94,17.76-17.75,17.76H303.38c-9.8,0-17.76-7.95-17.76-17.76V96.26 c0-9.81,7.96-17.76,17.76-17.76h35.12v6.01c0,4.97,4.03,8.99,8.99,8.99h72.4c4.96,0,8.99-4.02,8.99-8.99V78.5h20.72 C459.4,78.5,467.34,86.45,467.34,96.26z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    className: "st20",
    d: "M467.34,96.26v323.19c0,9.81-7.94,17.76-17.75,17.76H303.38c-9.8,0-17.76-7.95-17.76-17.76 V96.26c0-9.81,7.96-17.76,17.76-17.76h35.12v6.01c0,4.97,4.03,8.99,8.99,8.99h72.4c4.96,0,8.99-4.02,8.99-8.99V78.5h20.72 C459.4,78.5,467.34,86.45,467.34,96.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.6191,
    y1: 257.8599,
    x2: 467.3423,
    y2: 257.8599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M467.34,96.26v323.2c0,9.81-7.94,17.76-17.75,17.76H303.38c-9.8,0-17.76-7.95-17.76-17.76V96.26 c0-9.81,7.96-17.76,17.76-17.76h27.91v6c0,4.97,4.03,8.99,8.99,8.99h72.4c4.96,0,8.99-4.02,8.99-8.99v-6h27.92 C459.4,78.5,467.34,86.45,467.34,96.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.1191,
    y1: 257.8599,
    x2: 468.8423,
    y2: 257.8599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    style: {
      stopColor: "#024792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#039EC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M449.6,438.72H303.38c-10.62,0-19.26-8.64-19.26-19.26V96.26c0-10.62,8.64-19.26,19.26-19.26h29.41v7.5 c0,4.13,3.36,7.49,7.49,7.49h72.4c4.13,0,7.49-3.36,7.49-7.49V77h29.42c10.61,0,19.25,8.64,19.25,19.26v323.2 C468.84,430.08,460.21,438.72,449.6,438.72z M303.38,80c-8.96,0-16.26,7.29-16.26,16.26v323.2c0,8.96,7.29,16.26,16.26,16.26 H449.6c8.96,0,16.25-7.29,16.25-16.26V96.26c0-8.96-7.29-16.26-16.25-16.26h-26.42v4.5c0,5.79-4.71,10.49-10.49,10.49h-72.4 c-5.79,0-10.49-4.71-10.49-10.49V80H303.38z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_337_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.9386,
    y1: 87.5591,
    x2: 341.138,
    y2: 148.3154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1491,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4633,
    style: {
      stopColor: "#797979"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7194,
    style: {
      stopColor: "#383838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9045,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M399.41,105L291.2,201.92V96.27c0-3.25,1.28-6.3,3.59-8.62c2.29-2.29,5.35-3.56,8.59-3.56h21.96v6.6 c0,7.87,6.41,14.31,14.31,14.31H399.41z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_332_"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M443.5,88.8c-0.32,0-0.57,0.26-0.57,0.57c0,0.32,0.26,0.57,0.57,0.57c0.32,0,0.57-0.26,0.57-0.57 C444.07,89.05,443.82,88.8,443.5,88.8z M442.2,88.07l0.5,0.5c0.21-0.2,0.49-0.33,0.8-0.33c0.31,0,0.6,0.13,0.8,0.33l0.5-0.5 c-0.33-0.33-0.79-0.54-1.3-0.54C442.99,87.52,442.53,87.73,442.2,88.07z M441.1,86.96l0.5,0.5c0.49-0.49,1.16-0.79,1.9-0.79 c0.74,0,1.41,0.3,1.9,0.79l0.5-0.5c-0.62-0.62-1.47-1-2.4-1C442.56,85.97,441.71,86.35,441.1,86.96z M443.5,84.58 c-1.32,0-2.52,0.54-3.39,1.4l0.5,0.5c0.74-0.74,1.76-1.2,2.88-1.2c1.12,0,2.15,0.46,2.88,1.2l0.5-0.5 C446.02,85.11,444.82,84.58,443.5,84.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.1147,
    y1: 87.2583,
    x2: 447.8873,
    y2: 87.2583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M443.5,90.94c-0.87,0-1.57-0.71-1.57-1.57c0-0.05,0-0.1,0.01-0.15l-0.45-0.45 c-0.1-0.1-0.18-0.23-0.23-0.37c-0.13-0.05-0.26-0.13-0.37-0.23l-0.5-0.5c-0.08-0.08-0.15-0.18-0.2-0.28 c-0.1-0.05-0.2-0.12-0.28-0.2l-0.5-0.5c-0.39-0.39-0.39-1.02,0-1.41c1.09-1.09,2.55-1.7,4.09-1.7s3,0.6,4.09,1.7 c0.39,0.39,0.39,1.02,0,1.41l-0.5,0.5c-0.08,0.08-0.18,0.15-0.28,0.2c-0.05,0.1-0.12,0.2-0.2,0.28l-0.5,0.5 c-0.11,0.11-0.23,0.18-0.36,0.23c-0.05,0.14-0.13,0.26-0.23,0.37l-0.45,0.45c0,0.05,0.01,0.1,0.01,0.15 C445.07,90.23,444.37,90.94,443.5,90.94z M443.09,89.49c0.1,0.36,0.72,0.36,0.82,0c-0.12-0.05-0.23-0.12-0.32-0.21 c-0.14-0.04-0.17-0.02-0.19,0C443.32,89.37,443.21,89.44,443.09,89.49z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_326_"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M437.78,85.36v4.38h0.71v-4.38H437.78z M436.46,89.74h0.71v-3.58h-0.71V89.74z M435.13,89.74h0.71v-2.78 h-0.71V89.74z M433.81,89.74h0.71v-1.98h-0.71V89.74z M432.49,89.74h0.71v-1.17h-0.71V89.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.4863,
    y1: 87.5484,
    x2: 439.4917,
    y2: 87.5484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M438.49,90.74h-0.71c-0.11,0-0.21-0.02-0.31-0.05c-0.1,0.03-0.2,0.05-0.31,0.05h-0.71 c-0.11,0-0.21-0.02-0.31-0.05c-0.1,0.03-0.2,0.05-0.31,0.05h-0.71c-0.11,0-0.21-0.02-0.31-0.05c-0.1,0.03-0.2,0.05-0.31,0.05 h-0.71c-0.11,0-0.21-0.02-0.31-0.05c-0.1,0.03-0.2,0.05-0.31,0.05h-0.71c-0.55,0-1-0.45-1-1v-1.17c0-0.55,0.45-1,1-1h0.34 c0.09-0.46,0.5-0.8,0.98-0.8h0.34c0.09-0.46,0.5-0.8,0.98-0.8h0.34c0.09-0.46,0.5-0.8,0.98-0.8h0.34 c0.09-0.46,0.5-0.8,0.98-0.8h0.71c0.55,0,1,0.45,1,1v4.38C439.49,90.29,439.04,90.74,438.49,90.74z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_321_",
    className: "st18",
    d: "M449.13,86.56v2.26c0,0.31,0.25,0.57,0.57,0.57h5.22v-3.4h-5.22 C449.38,85.99,449.13,86.24,449.13,86.56z M457.25,87.13v-0.64c0-0.52-0.42-0.95-0.95-0.95h-6.67c-0.52,0-0.95,0.42-0.95,0.95 v2.39c0,0.52,0.42,0.95,0.95,0.95h6.67c0.52,0,0.95-0.42,0.95-0.95v-0.64h0.42v-1.11H457.25z M457.07,88.88 c0,0.42-0.34,0.77-0.77,0.77h-6.67c-0.42,0-0.77-0.34-0.77-0.77v-2.39c0-0.42,0.34-0.77,0.77-0.77h6.67 c0.42,0,0.77,0.34,0.77,0.77V88.88z M456.3,90.65h-6.67c-0.97,0-1.77-0.79-1.77-1.77v-2.4c0-0.97,0.79-1.77,1.77-1.77h6.67 c0.97,0,1.77,0.79,1.77,1.77v2.4v0C458.07,89.86,457.27,90.65,456.3,90.65z M449.86,88.65h6.21v-1.93h-6.21V88.65z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.5327,
    y1: 421.4961,
    x2: 334.5327,
    y2: 406.1504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1085,
    style: {
      stopColor: "#ECEEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#B9C2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    style: {
      stopColor: "#687CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#052580"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M342.92,421.5h-16.77c-4.24,0-7.67-3.44-7.67-7.67l0,0c0-4.24,3.43-7.67,7.67-7.67h16.77 c4.24,0,7.67,3.44,7.67,7.67l0,0C350.59,418.06,347.15,421.5,342.92,421.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.481,
    y1: 421.4961,
    x2: 376.481,
    y2: 406.1504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1085,
    style: {
      stopColor: "#ECEEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#B9C2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    style: {
      stopColor: "#687CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#052580"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M384.86,421.5H368.1c-4.24,0-7.67-3.44-7.67-7.67l0,0c0-4.24,3.44-7.67,7.67-7.67h16.77 c4.24,0,7.67,3.44,7.67,7.67l0,0C392.54,418.06,389.1,421.5,384.86,421.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.4291,
    y1: 421.4961,
    x2: 418.4291,
    y2: 406.1504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1085,
    style: {
      stopColor: "#ECEEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#B9C2DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    style: {
      stopColor: "#687CB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#052580"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M426.81,421.5h-16.77c-4.24,0-7.67-3.44-7.67-7.67l0,0c0-4.24,3.44-7.67,7.67-7.67h16.77 c4.24,0,7.67,3.44,7.67,7.67l0,0C434.49,418.06,431.05,421.5,426.81,421.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_318_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.2925,
    y1: 89.21,
    x2: 421.6704,
    y2: 89.21
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M421.67,84.67v6.01c0,4.97-4.03,8.99-8.99,8.99h-72.4c-4.96,0-8.99-4.02-8.99-8.99v-6.01v-5.92h90.38 V84.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.6318,
    y1: 89.1294,
    x2: 423.3286,
    y2: 89.1294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#954AE2"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M340.28,101.25c-5.87,0-10.65-4.78-10.65-10.65V77.01h93.7V90.6c0,5.87-4.78,10.65-10.65,10.65H340.28z  M332.95,90.6c0,4.04,3.29,7.33,7.33,7.33h72.4c4.04,0,7.33-3.29,7.33-7.33V80.33h-87.06V90.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.124,
    y1: 89.2085,
    x2: 395.4585,
    y2: 89.2085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03BEF2"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M392.29,92.38c-1.75,0-3.17-1.42-3.17-3.17c0-1.75,1.42-3.18,3.17-3.18c1.75,0,3.17,1.43,3.17,3.18 C395.46,90.96,394.04,92.38,392.29,92.38z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M392.29,93.71c-2.48,0-4.5-2.02-4.5-4.5c0-2.49,2.02-4.51,4.5-4.51c2.48,0,4.5,2.02,4.5,4.51 C396.79,91.69,394.77,93.71,392.29,93.71z M392.29,87.37c-1.01,0-1.84,0.83-1.84,1.85c0,1.01,0.82,1.84,1.84,1.84 c1.01,0,1.84-0.82,1.84-1.84C394.13,88.2,393.3,87.37,392.29,87.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.5044,
    y1: 89.2129,
    x2: 385.7607,
    y2: 89.2129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03BEF2"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M360.45,92.15c-1.62,0-2.94-1.32-2.94-2.94c0-1.62,1.32-2.94,2.94-2.94h22.37c1.62,0,2.94,1.32,2.94,2.94 c0,1.62-1.32,2.94-2.94,2.94H360.45z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M382.82,93.48h-22.37c-2.36,0-4.27-1.92-4.27-4.27s1.92-4.27,4.27-4.27h22.37c2.36,0,4.27,1.92,4.27,4.27 S385.18,93.48,382.82,93.48z M360.45,87.6c-0.89,0-1.61,0.72-1.61,1.61c0,0.89,0.73,1.61,1.61,1.61h22.37 c0.89,0,1.61-0.72,1.61-1.61c0-0.89-0.72-1.61-1.61-1.61H360.45z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.3394,
    y1: 393.0205,
    x2: 440.3394,
    y2: 357.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M422.62,387.15c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V387.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.6008,
    y1: 386.128,
    x2: 439.6008,
    y2: 365.4522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M449.94,375.79c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C445.31,365.45,449.94,370.08,449.94,375.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.7671,
    y1: 393.0205,
    x2: 397.7671,
    y2: 357.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M380.04,387.15c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V387.15z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M407.37,375.79c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C402.74,365.45,407.37,370.08,407.37,375.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1948,
    y1: 393.0205,
    x2: 355.1948,
    y2: 357.5752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M337.47,387.15c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V387.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.4562,
    y1: 386.128,
    x2: 354.4562,
    y2: 365.4522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M364.79,375.79c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C360.17,365.45,364.79,370.08,364.79,375.79z"
  })), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M294.9,387.15c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V387.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.8999,
    y1: 375.2979,
    x2: 331.3452,
    y2: 375.2979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M324.48,394.02h-23.71c-3.79,0-6.87-3.08-6.87-6.87v-23.71c0-3.79,3.08-6.87,6.87-6.87h23.71 c3.79,0,6.87,3.08,6.87,6.87v23.71C331.35,390.94,328.26,394.02,324.48,394.02z M300.77,358.58c-2.68,0-4.87,2.18-4.87,4.87 v23.71c0,2.68,2.18,4.87,4.87,4.87h23.71c2.68,0,4.87-2.18,4.87-4.87v-23.71c0-2.68-2.18-4.87-4.87-4.87H300.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.8838,
    y1: 386.128,
    x2: 311.8838,
    y2: 365.4522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 311.88,
    cy: 375.79,
    r: 10.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.3394,
    y1: 150.8994,
    x2: 440.3394,
    y2: 115.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M422.62,145.03c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V145.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.6008,
    y1: 144.0069,
    x2: 439.6008,
    y2: 123.3311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M449.94,133.67c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C445.31,123.33,449.94,127.96,449.94,133.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.7671,
    y1: 150.8994,
    x2: 397.7671,
    y2: 115.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M380.04,145.03c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V145.03z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M407.37,133.67c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C402.74,123.33,407.37,127.96,407.37,133.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1948,
    y1: 150.8994,
    x2: 355.1948,
    y2: 115.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M337.47,145.03c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V145.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.4562,
    y1: 144.0069,
    x2: 354.4562,
    y2: 123.3311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M364.79,133.67c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C360.17,123.33,364.79,127.96,364.79,133.67z"
  })), /*#__PURE__*/React.createElement("g", null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M294.9,145.03c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87v-23.71 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V145.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.8999,
    y1: 133.1767,
    x2: 331.3452,
    y2: 133.1767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M324.48,151.9h-23.71c-3.79,0-6.87-3.08-6.87-6.87v-23.71c0-3.79,3.08-6.87,6.87-6.87h23.71 c3.79,0,6.87,3.08,6.87,6.87v23.71C331.35,148.82,328.26,151.9,324.48,151.9z M300.77,116.45c-2.68,0-4.87,2.18-4.87,4.87 v23.71c0,2.68,2.18,4.87,4.87,4.87h23.71c2.68,0,4.87-2.18,4.87-4.87v-23.71c0-2.68-2.18-4.87-4.87-4.87H300.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.8838,
    y1: 144.0069,
    x2: 311.8838,
    y2: 123.3311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 311.88,
    cy: 133.67,
    r: 10.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.6226,
    y1: 196.8057,
    x2: 312.6226,
    y2: 161.3604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M330.35,167.23c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V167.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.3606,
    y1: 188.9297,
    x2: 313.3606,
    y2: 168.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M303.02,178.59c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C307.65,188.93,303.02,184.3,303.02,178.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1948,
    y1: 196.8057,
    x2: 355.1948,
    y2: 161.3604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M372.92,167.23c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V167.23z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M345.6,178.59c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C350.22,188.93,345.6,184.3,345.6,178.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.7671,
    y1: 196.8057,
    x2: 397.7671,
    y2: 161.3604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M415.49,167.23c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V167.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.5051,
    y1: 188.9297,
    x2: 398.5051,
    y2: 168.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M388.17,178.59c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C392.8,188.93,388.17,184.3,388.17,178.59z"
  })), /*#__PURE__*/React.createElement("g", null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M458.06,167.23c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V167.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.6167,
    y1: 179.0831,
    x2: 459.062,
    y2: 179.0831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M452.19,197.81h-23.71c-3.79,0-6.87-3.08-6.87-6.87v-23.71c0-3.79,3.08-6.87,6.87-6.87h23.71 c3.79,0,6.87,3.08,6.87,6.87v23.71C459.06,194.72,455.98,197.81,452.19,197.81z M428.48,162.36c-2.68,0-4.87,2.18-4.87,4.87 v23.71c0,2.68,2.18,4.87,4.87,4.87h23.71c2.68,0,4.87-2.18,4.87-4.87v-23.71c0-2.68-2.18-4.87-4.87-4.87H428.48z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.0774,
    y1: 188.9297,
    x2: 441.0774,
    y2: 168.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M430.74,178.59c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C435.37,188.93,430.74,184.3,430.74,178.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.3394,
    y1: 242.4737,
    x2: 440.3394,
    y2: 207.0283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M422.62,236.61c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V212.9 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V236.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.6008,
    y1: 235.5811,
    x2: 439.6008,
    y2: 214.9053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M449.94,225.24c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C445.31,214.91,449.94,219.53,449.94,225.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.7671,
    y1: 242.4737,
    x2: 397.7671,
    y2: 207.0283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M380.04,236.61c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V212.9 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V236.61z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M407.37,225.24c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C402.74,214.91,407.37,219.53,407.37,225.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1948,
    y1: 242.4737,
    x2: 355.1948,
    y2: 207.0283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M337.47,236.61c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V212.9 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V236.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.4562,
    y1: 235.5811,
    x2: 354.4562,
    y2: 214.9053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M364.79,225.24c0,5.71-4.63,10.34-10.34,10.34c-5.71,0-10.34-4.63-10.34-10.34 c0-5.71,4.63-10.34,10.34-10.34C360.17,214.91,364.79,219.53,364.79,225.24z"
  })), /*#__PURE__*/React.createElement("g", null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M294.9,236.61c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V212.9 c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87V236.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.8999,
    y1: 224.7515,
    x2: 331.3452,
    y2: 224.7515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M324.48,243.47h-23.71c-3.79,0-6.87-3.08-6.87-6.87V212.9c0-3.79,3.08-6.87,6.87-6.87h23.71 c3.79,0,6.87,3.08,6.87,6.87v23.71C331.35,240.39,328.26,243.47,324.48,243.47z M300.77,208.03c-2.68,0-4.87,2.18-4.87,4.87 v23.71c0,2.68,2.18,4.87,4.87,4.87h23.71c2.68,0,4.87-2.18,4.87-4.87V212.9c0-2.68-2.18-4.87-4.87-4.87H300.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.8838,
    y1: 235.5811,
    x2: 311.8838,
    y2: 214.9053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st62",
    cx: 311.88,
    cy: 225.24,
    r: 10.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.6226,
    y1: 288.3799,
    x2: 312.6226,
    y2: 252.9356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M330.35,258.8c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V258.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.3606,
    y1: 280.5039,
    x2: 313.3606,
    y2: 259.8282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M303.02,270.17c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C307.65,280.5,303.02,275.88,303.02,270.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.1948,
    y1: 288.3799,
    x2: 355.1948,
    y2: 252.9356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M372.92,258.8c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V258.8z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 32.2413 578.2272)",
    className: "st37",
    cx: 355.93,
    cy: 270.17,
    rx: 10.34,
    ry: 10.34
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.7671,
    y1: 288.3799,
    x2: 397.7671,
    y2: 252.9356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M415.49,258.8c0-3.24-2.63-5.87-5.87-5.87h-23.71c-3.24,0-5.87,2.63-5.87,5.87v23.71 c0,3.24,2.63,5.87,5.87,5.87h23.71c3.24,0,5.87-2.63,5.87-5.87V258.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.5051,
    y1: 280.5039,
    x2: 398.5051,
    y2: 259.8282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M388.17,270.17c0-5.71,4.63-10.34,10.34-10.34c5.71,0,10.34,4.63,10.34,10.34 c0,5.71-4.63,10.34-10.34,10.34C392.8,280.5,388.17,275.88,388.17,270.17z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.4183,
    y1: 929.3142,
    x2: 1579.9052,
    y2: 944.6248,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M581,351.77l11.84-5.25l13.85,31.22c1.44,3.24-0.02,7.03-3.26,8.46l-0.12,0.05 c-3.24,1.43-7.03-0.03-8.46-3.26L581,351.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 1556.9373,
    y1: 936.0349,
    x2: 1597.0314,
    y2: 936.0349,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M600.72,387.81c-2.84,0-5.56-1.64-6.79-4.41l-14.25-32.14l13.67-6.06l14.26,32.14 c0.8,1.81,0.85,3.82,0.14,5.67c-0.71,1.85-2.1,3.31-3.91,4.11l-0.12,0.05C602.74,387.6,601.72,387.81,600.72,387.81z  M582.32,352.28l13.44,30.31c1.21,2.73,4.42,3.96,7.14,2.75l0.12-0.05c1.32-0.59,2.34-1.65,2.86-3 c0.52-1.35,0.48-2.82-0.1-4.14l-13.45-30.31L582.32,352.28z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 1579.0333,
    y1: 896.4565,
    x2: 1681.9968,
    y2: 896.4565,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M519.31,286.36c-5.28,13.59-4.3,28.28,1.6,40.7c4.86,10.26,13.09,18.97,23.92,24.21 c1.25,0.6,2.57,1.16,3.85,1.65c6.58,2.56,13.44,3.73,20.41,3.5c1.13-0.04,2.27-0.13,3.39-0.25c3.16-0.33,6.28-0.96,9.35-1.87 c2.14-0.65,4.27-1.43,6.32-2.33c1.99-0.89,3.93-1.89,5.75-3.01c9.82-5.88,17.22-14.67,21.38-25.4 c4.97-12.83,4.64-26.8-0.92-39.4c-4.95-11.19-13.7-20.25-24.6-25.53c-1.27-0.59-2.54-1.18-3.87-1.68 c-12.82-4.96-26.87-4.6-39.46,0.98C533.86,263.49,524.21,273.58,519.31,286.36z M550.01,266.04 c10.46-4.63,22.05-4.92,32.66-0.82c1.08,0.44,2.17,0.9,3.2,1.39c9.05,4.38,16.26,11.89,20.34,21.15 c4.63,10.41,4.91,21.98,0.78,32.57c-4.08,10.54-12.05,18.89-22.44,23.52l-0.96,0.41c-1.79,0.72-3.61,1.33-5.44,1.81 c-8.78,2.32-17.87,1.82-26.28-1.42c-1.07-0.43-2.13-0.87-3.16-1.39c-11.07-5.35-18.86-15.08-22.18-26.21 c-2.62-8.78-2.46-18.42,1.05-27.48C531.69,278.99,539.65,270.64,550.01,266.04z M567.15,348.5c-5.32,0-10.6-0.98-15.64-2.92 c-1.11-0.45-2.19-0.89-3.26-1.43c-10.9-5.27-19.17-15.04-22.68-26.81c-2.79-9.38-2.42-19.11,1.07-28.13 c4.21-10.82,12.37-19.37,22.96-24.08h0c10.7-4.74,22.57-5.04,33.42-0.84c1.31,0.53,2.34,0.98,3.28,1.42 c9.25,4.47,16.64,12.16,20.82,21.65c4.74,10.66,5.02,22.5,0.8,33.34c-4.18,10.79-12.34,19.33-22.96,24.07l-0.98,0.41 c-1.86,0.75-3.73,1.37-5.57,1.85C574.69,348.01,570.91,348.5,567.15,348.5z M550.42,266.95c-10.11,4.5-17.89,12.66-21.91,22.98 c-3.33,8.6-3.69,17.88-1.02,26.84c3.35,11.23,11.25,20.55,21.66,25.59c1.01,0.52,2.04,0.94,3.1,1.37 c8.2,3.16,17.08,3.64,25.66,1.38c1.77-0.46,3.56-1.06,5.32-1.77l0.95-0.4c10.12-4.51,17.91-12.67,21.89-22.96 c4.03-10.34,3.76-21.64-0.76-31.8c-3.99-9.06-11.04-16.39-19.86-20.66c-0.89-0.43-1.89-0.86-3.14-1.37 C571.95,262.14,560.62,262.43,550.42,266.95L550.42,266.95z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.4183,
    y1: 929.3142,
    x2: 1579.9052,
    y2: 944.6248,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M581,351.77l11.84-5.25l13.85,31.22c1.44,3.24-0.02,7.03-3.26,8.46l-0.12,0.05 c-3.24,1.43-7.03-0.03-8.46-3.26L581,351.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 1556.9373,
    y1: 936.0349,
    x2: 1597.0314,
    y2: 936.0349,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M600.72,387.81c-2.84,0-5.56-1.64-6.79-4.41l-14.25-32.14l13.67-6.06l14.26,32.14 c0.8,1.81,0.85,3.82,0.14,5.67c-0.71,1.85-2.1,3.31-3.91,4.11l-0.12,0.05C602.74,387.6,601.72,387.81,600.72,387.81z  M582.32,352.28l13.44,30.31c1.21,2.73,4.42,3.96,7.14,2.75l0.12-0.05c1.32-0.59,2.34-1.65,2.86-3 c0.52-1.35,0.48-2.82-0.1-4.14l-13.45-30.31L582.32,352.28z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M581.5,366.28l21.77-9.66l25.47,57.42c2.64,5.95-0.04,12.92-6,15.56l-0.22,0.1 c-5.95,2.64-12.92-0.05-15.56-6L581.5,366.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 1517.7661,
    y1: 953.3971,
    x2: 1589.0854,
    y2: 953.3971,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M617.77,431.71c-4.91,0-9.6-2.84-11.71-7.61l-25.47-57.42c-0.22-0.5,0-1.1,0.51-1.32l21.77-9.66 c0.51-0.23,1.1,0,1.32,0.51l25.47,57.42c1.39,3.12,1.47,6.6,0.24,9.79c-1.23,3.19-3.63,5.71-6.75,7.09l-0.22,0.1 C621.26,431.36,619.5,431.71,617.77,431.71z M582.82,366.79l25.06,56.51c2.41,5.44,8.8,7.9,14.24,5.49l0.22-0.1 c2.64-1.17,4.66-3.29,5.7-5.98c1.04-2.69,0.96-5.62-0.21-8.26l-25.07-56.5L582.82,366.79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.1771,
    y1: 977.0308,
    x2: 1535.5795,
    y2: 977.0308,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M617.75,427.08c-1.38,0-2.74-0.35-3.99-1.05c-1.54-0.87-2.73-2.18-3.45-3.8l1.83-0.81 c0.54,1.22,1.44,2.21,2.6,2.86c1.71,0.96,3.72,1.06,5.51,0.26l0.81,1.83C619.99,426.84,618.87,427.08,617.75,427.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 1539.4802,
    y1: 969.3742,
    x2: 1550.4784,
    y2: 969.3742,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "607.73,416.41 602.77,405.22 604.59,404.41 609.55,415.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 1551.5396,
    y1: 962.0701,
    x2: 1557.9731,
    y2: 962.0701,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "601.62,402.65 598.97,396.67 600.8,395.86 603.45,401.84  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.4183,
    y1: 929.3142,
    x2: 1579.9052,
    y2: 944.6248,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M581,351.77l11.84-5.25l13.85,31.22c1.44,3.24-0.02,7.03-3.26,8.46l-0.12,0.05 c-3.24,1.43-7.03-0.03-8.46-3.26L581,351.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 1556.9373,
    y1: 936.0349,
    x2: 1597.0314,
    y2: 936.0349,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M600.72,387.81c-2.84,0-5.56-1.64-6.79-4.41l-14.25-32.14l13.67-6.06l14.26,32.14 c0.8,1.81,0.85,3.82,0.14,5.67c-0.71,1.85-2.1,3.31-3.91,4.11l-0.12,0.05C602.74,387.6,601.72,387.81,600.72,387.81z  M582.32,352.28l13.44,30.31c1.21,2.73,4.42,3.96,7.14,2.75l0.12-0.05c1.32-0.59,2.34-1.65,2.86-3 c0.52-1.35,0.48-2.82-0.1-4.14l-13.45-30.31L582.32,352.28z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M581.5,366.28l21.77-9.66l25.47,57.42c2.64,5.95-0.04,12.92-6,15.56l-0.22,0.1 c-5.95,2.64-12.92-0.05-15.56-6L581.5,366.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 1517.7661,
    y1: 953.3971,
    x2: 1589.0854,
    y2: 953.3971,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M617.77,431.71c-4.91,0-9.6-2.84-11.71-7.61l-25.47-57.42c-0.22-0.5,0-1.1,0.51-1.32l21.77-9.66 c0.51-0.23,1.1,0,1.32,0.51l25.47,57.42c1.39,3.12,1.47,6.6,0.24,9.79c-1.23,3.19-3.63,5.71-6.75,7.09l-0.22,0.1 C621.26,431.36,619.5,431.71,617.77,431.71z M582.82,366.79l25.06,56.51c2.41,5.44,8.8,7.9,14.24,5.49l0.22-0.1 c2.64-1.17,4.66-3.29,5.7-5.98c1.04-2.69,0.96-5.62-0.21-8.26l-25.07-56.5L582.82,366.79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.1771,
    y1: 977.0308,
    x2: 1535.5795,
    y2: 977.0308,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M617.75,427.08c-1.38,0-2.74-0.35-3.99-1.05c-1.54-0.87-2.73-2.18-3.45-3.8l1.83-0.81 c0.54,1.22,1.44,2.21,2.6,2.86c1.71,0.96,3.72,1.06,5.51,0.26l0.81,1.83C619.99,426.84,618.87,427.08,617.75,427.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 1539.4802,
    y1: 969.3742,
    x2: 1550.4784,
    y2: 969.3742,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "607.73,416.41 602.77,405.22 604.59,404.41 609.55,415.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 1551.5396,
    y1: 962.0701,
    x2: 1557.9731,
    y2: 962.0701,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "601.62,402.65 598.97,396.67 600.8,395.86 603.45,401.84  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M581.5,366.28l21.77-9.66l25.47,57.42c2.64,5.95-0.04,12.92-6,15.56l-0.22,0.1 c-5.95,2.64-12.92-0.05-15.56-6L581.5,366.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 1517.7661,
    y1: 953.3971,
    x2: 1589.0854,
    y2: 953.3971,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M617.77,431.71c-4.91,0-9.6-2.84-11.71-7.61l-25.47-57.42c-0.22-0.5,0-1.1,0.51-1.32l21.77-9.66 c0.51-0.23,1.1,0,1.32,0.51l25.47,57.42c1.39,3.12,1.47,6.6,0.24,9.79c-1.23,3.19-3.63,5.71-6.75,7.09l-0.22,0.1 C621.26,431.36,619.5,431.71,617.77,431.71z M582.82,366.79l25.06,56.51c2.41,5.44,8.8,7.9,14.24,5.49l0.22-0.1 c2.64-1.17,4.66-3.29,5.7-5.98c1.04-2.69,0.96-5.62-0.21-8.26l-25.07-56.5L582.82,366.79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 1524.1771,
    y1: 977.0308,
    x2: 1535.5795,
    y2: 977.0308,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M617.75,427.08c-1.38,0-2.74-0.35-3.99-1.05c-1.54-0.87-2.73-2.18-3.45-3.8l1.83-0.81 c0.54,1.22,1.44,2.21,2.6,2.86c1.71,0.96,3.72,1.06,5.51,0.26l0.81,1.83C619.99,426.84,618.87,427.08,617.75,427.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 1539.4802,
    y1: 969.3742,
    x2: 1550.4784,
    y2: 969.3742,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "607.73,416.41 602.77,405.22 604.59,404.41 609.55,415.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 1551.5396,
    y1: 962.0701,
    x2: 1557.9731,
    y2: 962.0701,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "601.62,402.65 598.97,396.67 600.8,395.86 603.45,401.84  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 1579.0333,
    y1: 896.4565,
    x2: 1681.9968,
    y2: 896.4565,
    gradientTransform: "matrix(-0.8719 -0.4897 -0.4897 0.8719 2427.9292 321.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M519.31,286.36c-5.28,13.59-4.3,28.28,1.6,40.7c4.86,10.26,13.09,18.97,23.92,24.21 c1.25,0.6,2.57,1.16,3.85,1.65c6.58,2.56,13.44,3.73,20.41,3.5c1.13-0.04,2.27-0.13,3.39-0.25c3.16-0.33,6.28-0.96,9.35-1.87 c2.14-0.65,4.27-1.43,6.32-2.33c1.99-0.89,3.93-1.89,5.75-3.01c9.82-5.88,17.22-14.67,21.38-25.4 c4.97-12.83,4.64-26.8-0.92-39.4c-4.95-11.19-13.7-20.25-24.6-25.53c-1.27-0.59-2.54-1.18-3.87-1.68 c-12.82-4.96-26.87-4.6-39.46,0.98C533.86,263.49,524.21,273.58,519.31,286.36z M550.01,266.04 c10.46-4.63,22.05-4.92,32.66-0.82c1.08,0.44,2.17,0.9,3.2,1.39c9.05,4.38,16.26,11.89,20.34,21.15 c4.63,10.41,4.91,21.98,0.78,32.57c-4.08,10.54-12.05,18.89-22.44,23.52l-0.96,0.41c-1.79,0.72-3.61,1.33-5.44,1.81 c-8.78,2.32-17.87,1.82-26.28-1.42c-1.07-0.43-2.13-0.87-3.16-1.39c-11.07-5.35-18.86-15.08-22.18-26.21 c-2.62-8.78-2.46-18.42,1.05-27.48C531.69,278.99,539.65,270.64,550.01,266.04z M567.15,348.5c-5.32,0-10.6-0.98-15.64-2.92 c-1.11-0.45-2.19-0.89-3.26-1.43c-10.9-5.27-19.17-15.04-22.68-26.81c-2.79-9.38-2.42-19.11,1.07-28.13 c4.21-10.82,12.37-19.37,22.96-24.08h0c10.7-4.74,22.57-5.04,33.42-0.84c1.31,0.53,2.34,0.98,3.28,1.42 c9.25,4.47,16.64,12.16,20.82,21.65c4.74,10.66,5.02,22.5,0.8,33.34c-4.18,10.79-12.34,19.33-22.96,24.07l-0.98,0.41 c-1.86,0.75-3.73,1.37-5.57,1.85C574.69,348.01,570.91,348.5,567.15,348.5z M550.42,266.95c-10.11,4.5-17.89,12.66-21.91,22.98 c-3.33,8.6-3.69,17.88-1.02,26.84c3.35,11.23,11.25,20.55,21.66,25.59c1.01,0.52,2.04,0.94,3.1,1.37 c8.2,3.16,17.08,3.64,25.66,1.38c1.77-0.46,3.56-1.06,5.32-1.77l0.95-0.4c10.12-4.51,17.91-12.67,21.89-22.96 c4.03-10.34,3.76-21.64-0.76-31.8c-3.99-9.06-11.04-16.39-19.86-20.66c-0.89-0.43-1.89-0.86-3.14-1.37 C571.95,262.14,560.62,262.43,550.42,266.95L550.42,266.95z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_340_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_345_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M591.79,199.98c8.06,0,14.59,5.63,14.59,12.58c0,4.17-2.35,7.87-5.98,10.16l2.05,5.2l-5.04-3.74 c-1.73,0.63-3.63,0.97-5.63,0.97c-8.06,0-14.59-5.63-14.59-12.59C577.21,205.62,583.74,199.98,591.79,199.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.0541,
    y1: 214.9048,
    x2: 398.2299,
    y2: 214.9048,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M604.68,230.83l-7.43-5.52c-1.74,0.57-3.57,0.85-5.45,0.85c-8.59,0-15.59-6.09-15.59-13.59 c0-7.49,6.99-13.58,15.59-13.58c8.59,0,15.59,6.09,15.59,13.58c0,4.09-2.14,7.98-5.75,10.54L604.68,230.83z M597.59,223.06 l2.65,1.97l-1.07-2.7l0.7-0.44c3.45-2.18,5.51-5.66,5.51-9.32c0-6.39-6.1-11.58-13.59-11.58c-7.49,0-13.59,5.2-13.59,11.58 c0,6.39,6.1,11.59,13.59,11.59c1.83,0,3.61-0.31,5.29-0.91L597.59,223.06z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_341_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_344_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.0453,
    y1: 212.8179,
    x2: 391.0004,
    y2: 212.8179,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M598.17,214.79c-1.09,0-1.98-0.89-1.98-1.98s0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 S599.26,214.79,598.17,214.79z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_343_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.6654,
    y1: 212.8179,
    x2: 384.6186,
    y2: 212.8179,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M591.79,214.79c-1.09,0-1.98-0.89-1.98-1.98s0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 S592.88,214.79,591.79,214.79z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_342_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.2846,
    y1: 212.8179,
    x2: 378.2387,
    y2: 212.8179,
    gradientTransform: "matrix(1 0 0 1 209.1524 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M585.41,214.79c-1.09,0-1.98-0.89-1.98-1.98s0.89-1.98,1.98-1.98c1.09,0,1.98,0.89,1.98,1.98 S586.5,214.79,585.41,214.79z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.6097,
    y1: 141.1326,
    x2: 528.6004,
    y2: 141.1326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M519.18,148.63h-0.15c-0.46,0-0.9-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.38,0.55-3.07c0.98-0.67,2.4-0.4,3.06,0.56l5.49,7.89l5.49-7.89c0.66-0.96,2.09-1.22,3.06-0.55 c1,0.69,1.25,2.07,0.56,3.07l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24C520.07,148.5,519.64,148.63,519.18,148.63z  M519.16,146.63l0.02,1v-1c0.07,0,0.1-0.02,0.12-0.03c0.04-0.03,0.07-0.07,0.08-0.13l0.03-0.24l7.16-10.29 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.13-0.18-0.22-0.09-0.28-0.05 c-0.09,0.06-0.11,0.19-0.04,0.29l7.15,10.28l0.03,0.24c0.01,0.04,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.12,0.03H519.16z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.609,
    y1: 130.3355,
    x2: 528.6019,
    y2: 130.3355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M519.19,137.83h-0.16c-0.46,0-0.89-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.06,0.55l5.49,7.9l5.49-7.9c0.66-0.96,2.1-1.22,3.07-0.55 c0.48,0.33,0.8,0.83,0.91,1.41c0.11,0.58-0.02,1.16-0.36,1.65l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24 C520.07,137.7,519.64,137.83,519.19,137.83z M519.17,135.83l0.02,1v-1c0.06,0,0.09-0.02,0.12-0.03 c0.06-0.04,0.07-0.1,0.08-0.13l0.03-0.24l7.16-10.29c0.04-0.06,0.04-0.12,0.03-0.15c-0.01-0.04-0.03-0.09-0.08-0.13 c-0.07-0.05-0.16-0.13-0.28,0.04l-7.13,10.27l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.07-0.12,0.19-0.05,0.29 l7.15,10.28l0.03,0.24c0,0.03,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.11,0.03H519.17z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.1492,
    y1: 119.5401,
    x2: 528.1379,
    y2: 119.5401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M518.73,127.04h-0.17c-0.46,0-0.89-0.13-1.26-0.39c-0.42-0.29-0.73-0.73-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.39,0.56-3.07c0.96-0.67,2.39-0.41,3.06,0.55l5.49,7.89l5.48-7.89c0.67-0.96,2.1-1.22,3.06-0.55 c1,0.69,1.25,2.07,0.55,3.07l-6.9,9.92c-0.13,0.51-0.44,0.95-0.87,1.24C519.62,126.9,519.18,127.04,518.73,127.04z  M518.71,125.04l0.02,1v-1c0.06,0,0.09-0.02,0.11-0.03c0.06-0.04,0.08-0.1,0.08-0.14l0.03-0.24l7.15-10.28 c0.07-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05 c-0.1,0.07-0.12,0.2-0.05,0.3l7.14,10.27l0.03,0.24c0,0.03,0.02,0.1,0.08,0.13c0.03,0.02,0.06,0.03,0.11,0.03H518.71z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.1475,
    y1: 108.7426,
    x2: 528.1399,
    y2: 108.7426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M518.73,116.24h-0.18c-0.44,0-0.87-0.13-1.24-0.38c-0.44-0.31-0.74-0.75-0.88-1.25l-6.9-9.93 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.06,0.55l5.49,7.89l5.48-7.89c0.67-0.96,2.1-1.22,3.06-0.55 c0.49,0.34,0.81,0.84,0.91,1.42c0.11,0.58-0.02,1.17-0.36,1.65l-6.9,9.93c-0.13,0.5-0.44,0.94-0.86,1.24 C519.6,116.11,519.17,116.24,518.73,116.24z M518.72,114.24l0.02,1v-1c0.04,0,0.08-0.01,0.12-0.04 c0.03-0.02,0.06-0.07,0.07-0.13l0.03-0.24l7.15-10.29c0.06-0.08,0.03-0.23-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05 l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.06-0.12,0.19-0.05,0.29l7.15,10.29l0.03,0.24 c0,0.04,0.02,0.1,0.09,0.14c0.02,0.01,0.06,0.03,0.1,0.03H518.72z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.7861,
    y1: 138.4758,
    x2: 266.7767,
    y2: 138.4758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M257.36,145.97h-0.15c-0.46,0-0.9-0.13-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.38,0.55-3.07c0.98-0.67,2.4-0.4,3.06,0.56l5.49,7.89l5.49-7.89c0.66-0.96,2.09-1.22,3.06-0.56 c1,0.69,1.25,2.07,0.56,3.07l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24C258.25,145.84,257.81,145.97,257.36,145.97z  M257.34,143.97l0.02,1v-1c0.07,0,0.1-0.02,0.12-0.03c0.04-0.03,0.07-0.07,0.08-0.13l0.03-0.24l7.15-10.29 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.13-0.18-0.22-0.09-0.28-0.05 c-0.09,0.06-0.11,0.19-0.04,0.29l7.15,10.28l0.03,0.24c0.01,0.04,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.12,0.03H257.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.7856,
    y1: 127.6791,
    x2: 266.7784,
    y2: 127.6791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M257.36,135.18h-0.16c-0.46,0-0.89-0.14-1.26-0.39c-0.43-0.3-0.73-0.74-0.86-1.24l-6.9-9.92 c-0.69-1-0.44-2.38,0.55-3.07c0.95-0.67,2.4-0.41,3.06,0.55l5.49,7.9l5.49-7.9c0.66-0.96,2.1-1.22,3.07-0.55 c0.48,0.33,0.8,0.83,0.91,1.41c0.1,0.58-0.02,1.17-0.36,1.65l-6.9,9.92c-0.13,0.5-0.44,0.94-0.87,1.24 C258.25,135.04,257.81,135.18,257.36,135.18z M257.34,133.18l0.02,1v-1c0.06,0,0.09-0.02,0.12-0.03 c0.06-0.04,0.07-0.1,0.08-0.13l0.03-0.24l7.15-10.29c0.04-0.06,0.04-0.11,0.03-0.15c-0.01-0.04-0.03-0.09-0.08-0.13 c-0.07-0.05-0.16-0.13-0.28,0.04l-7.13,10.27l-7.13-10.26c-0.12-0.17-0.22-0.09-0.28-0.05c-0.09,0.07-0.12,0.19-0.05,0.29 l7.15,10.28l0.03,0.24c0,0.03,0.02,0.1,0.08,0.14c0.01,0.01,0.04,0.03,0.11,0.03H257.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.3257,
    y1: 116.8836,
    x2: 266.3144,
    y2: 116.8836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M256.91,124.38h-0.17c-0.46,0-0.89-0.14-1.26-0.39c-0.42-0.29-0.73-0.73-0.86-1.24l-6.9-9.92 c-0.69-1.01-0.44-2.39,0.56-3.07c0.96-0.67,2.39-0.41,3.06,0.55l5.49,7.9l5.48-7.9c0.67-0.96,2.1-1.22,3.06-0.55 c1,0.69,1.25,2.07,0.55,3.07l-6.9,9.92c-0.13,0.5-0.44,0.95-0.87,1.24C257.79,124.24,257.36,124.38,256.91,124.38z  M256.89,122.38l0.02,1v-1c0.06,0,0.09-0.02,0.11-0.03c0.06-0.04,0.08-0.1,0.08-0.14l0.03-0.24l7.15-10.28 c0.06-0.09,0.04-0.22-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05 c-0.1,0.07-0.12,0.2-0.05,0.3l7.14,10.27l0.03,0.24c0,0.03,0.02,0.1,0.08,0.13c0.03,0.02,0.06,0.03,0.11,0.03L256.89,122.38z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.3239,
    y1: 106.0862,
    x2: 266.3164,
    y2: 106.0862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M256.91,113.58h-0.18c-0.44,0-0.87-0.13-1.24-0.38c-0.44-0.31-0.74-0.75-0.88-1.25l-6.9-9.93 c-0.69-1-0.44-2.38,0.55-3.07c0.96-0.67,2.4-0.41,3.06,0.55l5.49,7.89l5.48-7.89c0.67-0.96,2.1-1.22,3.06-0.55 c0.48,0.34,0.81,0.84,0.91,1.42c0.11,0.58-0.02,1.17-0.36,1.65l-6.9,9.93c-0.13,0.5-0.44,0.94-0.86,1.24 C257.78,113.45,257.35,113.58,256.91,113.58z M256.89,111.58l0.02,1v-1c0.04,0,0.08-0.01,0.12-0.04 c0.03-0.02,0.06-0.07,0.07-0.13l0.03-0.24l7.15-10.29c0.06-0.08,0.03-0.23-0.05-0.29c-0.06-0.04-0.16-0.13-0.28,0.05 l-7.13,10.26l-7.13-10.26c-0.12-0.18-0.22-0.09-0.28-0.05c-0.09,0.06-0.12,0.19-0.05,0.29l7.15,10.29l0.03,0.24 c0.01,0.04,0.02,0.1,0.08,0.14c0.02,0.01,0.06,0.03,0.1,0.03H256.89z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.9971,
    y1: 224.7515,
    x2: 227.9966,
    y2: 224.7515
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M161.23,231.09c-4.18,0-8.11-1.51-11.07-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 c-1.11,1.03-2.99,0.96-4.02-0.15c-1.07-1.15-1-2.95,0.15-4.02c2.96-2.75,6.89-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.91,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.96-2.75,6.88-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.91,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.95-2.75,6.88-4.26,11.06-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.15,1.07,1.21,2.87,0.15,4.02c-1.03,1.11-2.91,1.17-4.02,0.15c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.19,2.76 c-2.96,2.75-6.89,4.26-11.07,4.26c-4.18,0-8.11-1.51-11.06-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 C169.34,229.58,165.41,231.09,161.23,231.09z M142.97,222.07c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.29-2.12,5.33-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.68,0,7.12-1.32,9.71-3.72c2.28-2.12,5.32-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c0.33,0.31,0.88,0.29,1.19-0.04 c0.32-0.34,0.3-0.87-0.04-1.19c-2.58-2.4-6.03-3.72-9.7-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.71,3.72c-0.34,0.32-0.36,0.85-0.04,1.19 c0.3,0.33,0.86,0.35,1.19,0.04C136.7,223.24,139.74,222.07,142.97,222.07z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.2065,
    y1: 175.4453,
    x2: 597.2065,
    y2: 175.4453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 557.21,
    y: 174.45,
    className: "st102",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.6098,
    y1: 89.1299,
    x2: 529.6098,
    y2: 89.1299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 489.61,
    y: 88.13,
    className: "st103",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.56,
    y1: 244.0957,
    x2: 582.56,
    y2: 244.0957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 542.56,
    y: 243.1,
    className: "st104",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.7261,
    y1: 244.0957,
    x2: 597.6333,
    y2: 244.0957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 586.73,
    y: 243.1,
    className: "st105",
    width: 10.91,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.9673,
    y1: 142.8701,
    x2: 561.3305,
    y2: 142.8701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 538.97,
    y: 141.87,
    className: "st106",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.4282,
    y1: 159.9336,
    x2: 520.7915,
    y2: 159.9336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 498.43,
    y: 158.93,
    className: "st107",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.9428,
    y1: 131.1631,
    x2: 569.0815,
    y2: 131.1631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 558.94,
    y: 130.16,
    className: "st108",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.7544,
    y1: 158.9337,
    x2: 548.6147,
    y2: 158.9337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M545.18,162.36c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 C548.61,160.83,547.08,162.36,545.18,162.36z M545.18,157.5c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C546.61,158.14,545.97,157.5,545.18,157.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 625.7612,
    y1: 239.7168,
    x2: 635.9009,
    y2: 239.7168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 625.76,
    y: 238.72,
    className: "st110",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 610.1147,
    y1: 251.4742,
    x2: 616.9751,
    y2: 251.4742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M613.55,254.9c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C616.98,253.37,615.44,254.9,613.55,254.9z M613.55,250.04c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C614.98,250.68,614.33,250.04,613.55,250.04z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.1435,
    y1: 163.8628,
    x2: 227.0044,
    y2: 163.8628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M223.57,167.29c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C227,165.75,225.47,167.29,223.57,167.29z M223.57,162.43c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C225,163.07,224.36,162.43,223.57,162.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.6665,
    y1: 201.1626,
    x2: 570.0962,
    y2: 201.1626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "566.08,203.88 564.67,202.46 568.68,198.45 570.1,199.86  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1326.5527,
    y1: 668.9971,
    x2: 1331.9834,
    y2: 668.9971,
    gradientTransform: "matrix(0 1 -1 0 1236.3784 -1128.1053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "568.68,203.88 564.67,199.86 566.08,198.45 570.1,202.46  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.9458,
    y1: 100.5117,
    x2: 569.3755,
    y2: 100.5117
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "565.36,103.23 563.95,101.81 567.96,97.8 569.38,99.21  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 1225.9023,
    y1: 669.7178,
    x2: 1231.332,
    y2: 669.7178,
    gradientTransform: "matrix(0 1 -1 0 1236.3784 -1128.1053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "567.96,103.23 563.95,99.21 565.36,97.8 569.38,101.81  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2075.3838,
    y1: -51.7148,
    x2: 2115.3838,
    y2: -51.7148,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 171.23,
    y: 173.45,
    className: "st117",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 2059.4297,
    y1: 14.9463,
    x2: 2099.4297,
    y2: 14.9463,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 187.18,
    y: 106.78,
    className: "st118",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2135.3901,
    y1: -51.7148,
    x2: 2164.4424,
    y2: -51.7148,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 122.17,
    y: 173.45,
    className: "st119",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 2151.6519,
    y1: -16.2861,
    x2: 2159.5732,
    y2: -16.2861,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 127.04,
    y: 138.02,
    className: "st120",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 2097.4272,
    y1: -86.0439,
    x2: 2128.9927,
    y2: -86.0439,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 157.62,
    y: 207.77,
    className: "st121",
    width: 31.57,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 2149.9683,
    y1: -86.0439,
    x2: 2164.2798,
    y2: -86.0439,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 207.77,
    className: "st122",
    width: 14.31,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 2079.4297,
    y1: 36.1949,
    x2: 2086.291,
    y2: 36.1949,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M203.75,89.97c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 S205.64,89.97,203.75,89.97z M203.75,85.11c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43c0.79,0,1.43-0.64,1.43-1.43 C205.18,85.75,204.54,85.11,203.75,85.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 2146.4873,
    y1: -64.9771,
    x2: 2153.3486,
    y2: -64.9771,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M136.69,191.14c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 C140.12,189.6,138.58,191.14,136.69,191.14z M136.69,186.28c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C138.12,186.92,137.48,186.28,136.69,186.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1721.8491,
    y1: -95.2007,
    x2: 1728.7094,
    y2: -95.2007,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M561.33,221.36c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 S563.22,221.36,561.33,221.36z M561.33,216.5c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C562.76,217.14,562.12,216.5,561.33,216.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 2097.4272,
    y1: 29.2514,
    x2: 2102.8569,
    y2: 29.2514,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "185.17,96.19 183.75,94.78 187.77,90.76 189.18,92.18  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 2048.0972,
    y1: 31.9663,
    x2: 2053.5269,
    y2: 31.9663,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "234.5,93.48 233.08,92.07 237.1,88.05 238.51,89.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.356,
    y1: -814.433,
    x2: 1162.7866,
    y2: -814.433,
    gradientTransform: "matrix(0 -1 1 0 1050.2303 1250.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "237.1,93.48 233.08,89.46 234.5,88.05 238.51,92.07  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 2060.3208,
    y1: -130.7325,
    x2: 2065.7505,
    y2: -130.7325,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "222.27,256.18 220.86,254.76 224.87,250.75 226.29,252.16  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 994.6577,
    y1: -826.6567,
    x2: 1000.0874,
    y2: -826.6567,
    gradientTransform: "matrix(0 -1 1 0 1050.2303 1250.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "224.87,256.18 220.86,252.16 222.27,250.75 226.29,254.76  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 2057.2129,
    y1: -72.6455,
    x2: 2079.5762,
    y2: -72.6455,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 207.03,
    y: 194.38,
    className: "st131",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 2094.437,
    y1: -72.6455,
    x2: 2104.5762,
    y2: -72.6455,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 182.03,
    y: 194.38,
    className: "st132",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2013.6992,
    y1: -36.2032,
    x2: 2020.5605,
    y2: -36.2032,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M269.48,162.36c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C272.91,160.83,271.37,162.36,269.48,162.36z M269.48,157.5c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C270.91,158.14,270.27,157.5,269.48,157.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 2104.3135,
    y1: -139.0996,
    x2: 2112.2349,
    y2: -139.0996,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 174.37,
    y: 260.83,
    className: "st134",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 2117.1235,
    y1: -124.08,
    x2: 2122.5532,
    y2: -124.08,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st135",
    points: "165.47,249.53 164.06,248.11 168.07,244.1 169.49,245.51  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 1001.3101,
    y1: -883.4595,
    x2: 1006.7398,
    y2: -883.4595,
    gradientTransform: "matrix(0 -1 1 0 1050.2303 1250.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "168.07,249.53 164.06,245.51 165.47,244.1 169.49,248.11  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 2089.6089,
    y1: -126.795,
    x2: 2096.4702,
    y2: -126.795,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M193.57,252.96c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43c1.89,0,3.43,1.54,3.43,3.43 S195.46,252.96,193.57,252.96z M193.57,248.09c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C195,248.74,194.36,248.09,193.57,248.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 2011.7001,
    y1: 41.355,
    x2: 2017.1298,
    y2: 41.355,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st138",
    points: "270.89,84.09 269.48,82.68 273.5,78.66 274.91,80.07  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 1166.7448,
    y1: -778.0361,
    x2: 1172.1753,
    y2: -778.0361,
    gradientTransform: "matrix(0 -1 1 0 1050.2303 1250.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st139",
    points: "273.5,84.09 269.48,80.07 270.89,78.66 274.91,82.68  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 2117.1235,
    y1: 9.1475,
    x2: 2122.5537,
    y2: 9.1475,
    gradientTransform: "matrix(-1 0 0 -1 2286.6094 122.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st140",
    points: "165.47,116.3 164.06,114.88 168.07,110.87 169.49,112.28  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: 1134.5376,
    y1: -883.4597,
    x2: 1139.9673,
    y2: -883.4597,
    gradientTransform: "matrix(0 -1 1 0 1050.2303 1250.8354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st141",
    points: "168.07,116.3 164.06,112.28 165.47,110.87 169.49,114.88  "
  }))))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M254.12,407.37v9.85c0,7.46,6.04,13.5,13.5,13.5l0,0c7.46,0,13.5-6.04,13.5-13.5v-9.85H254.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M254.12,407.37v9.85c0,7.46,6.04,13.5,13.5,13.5l0,0c7.46,0,13.5-6.04,13.5-13.5v-9.85H254.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1162,
    y1: 419.043,
    x2: 282.1142,
    y2: 419.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M267.62,431.72c-7.99,0-14.5-6.5-14.5-14.5v-9.85c0-0.55,0.45-1,1-1h27c0.55,0,1,0.45,1,1v9.85 C282.11,425.21,275.61,431.72,267.62,431.72z M255.12,408.37v8.85c0,6.89,5.61,12.5,12.5,12.5s12.5-5.61,12.5-12.5v-8.85 H255.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M276.78,298.83L276.78,298.83v-17.96h-18.33v17.96l0,0c-2.39,0-4.33,1.94-4.33,4.33v104.21h27V303.16 C281.11,300.77,279.17,298.83,276.78,298.83z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1162,
    y1: 344.1187,
    x2: 282.1142,
    y2: 344.1187
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M281.11,408.37h-27c-0.55,0-1-0.45-1-1v-104.2c0-2.6,1.87-4.77,4.33-5.24v-17.05c0-0.55,0.45-1,1-1 h18.33c0.55,0,1,0.45,1,1v17.05c2.46,0.47,4.33,2.64,4.33,5.24v104.2C282.11,407.92,281.67,408.37,281.11,408.37z  M255.12,406.37h25v-103.2c0-1.84-1.5-3.33-3.33-3.33c-0.55,0-1-0.45-1-1v-16.96h-16.33v16.96c0,0.55-0.45,1-1,1 c-1.84,0-3.33,1.5-3.33,3.33V406.37z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.6152,
    y1: 280.8692,
    x2: 267.6152,
    y2: 170.0616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M275.49,267.34h-1.57v-56.79h0.17c3.62,0,6.59-2.96,6.59-6.59V183.1c0-7.17-5.87-13.04-13.04-13.04 c-7.2,0-13.1,5.89-13.1,13.1v20.63c0,3.72,3.04,6.76,6.76,6.76v56.79h-1.57c-3.73,0-6.76,3.03-6.76,6.76 c0,3.73,3.03,6.76,6.76,6.76h15.75c3.73,0,6.76-3.03,6.76-6.76C282.25,270.37,279.23,267.34,275.49,267.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.9775,
    y1: 225.4659,
    x2: 283.2529,
    y2: 225.4659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M275.49,281.87h-15.75c-4.28,0-7.76-3.48-7.76-7.76c0-4.28,3.48-7.76,7.76-7.76h0.57v-54.86 c-3.81-0.49-6.76-3.76-6.76-7.7v-20.63c0-7.77,6.32-14.09,14.09-14.09c7.74,0,14.04,6.3,14.04,14.04v20.86 c0,3.91-2.97,7.13-6.76,7.54v54.84h0.57c4.28,0,7.76,3.48,7.76,7.76C283.25,278.39,279.77,281.87,275.49,281.87z M259.74,268.34 c-3.18,0-5.76,2.58-5.76,5.76c0,3.18,2.59,5.76,5.76,5.76h15.75c3.18,0,5.76-2.58,5.76-5.76c0-3.18-2.58-5.76-5.76-5.76h-2.57 v-58.79h1.17c3.08,0,5.59-2.51,5.59-5.59V183.1c0-6.64-5.4-12.04-12.04-12.04c-6.67,0-12.09,5.43-12.09,12.09v20.63 c0,3.18,2.59,5.76,5.76,5.76h1v58.79H259.74z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3725,
    y1: 430.7178,
    x2: 538.2915,
    y2: 430.7178
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 402.37,
    y: 417.92,
    className: "st147",
    width: 135.92,
    height: 25.6
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M539.29,444.52H401.37v-27.6h137.92V444.52z M403.37,442.52h133.92v-23.6H403.37V442.52z"
  }))), /*#__PURE__*/React.createElement("g", null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M419.56,435.63c0,2.05-1.67,3.72-3.72,3.72c-2.05,0-3.72-1.67-3.72-3.72c0-2.05,1.67-3.72,3.72-3.72 C417.9,431.91,419.56,433.57,419.56,435.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.7832,
    y1: 435.626,
    x2: 420.9009,
    y2: 435.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M415.84,440.68c-2.79,0-5.06-2.27-5.06-5.06c0-2.79,2.27-5.06,5.06-5.06c2.79,0,5.06,2.27,5.06,5.06 C420.9,438.41,418.63,440.68,415.84,440.68z M415.84,433.25c-1.31,0-2.38,1.07-2.38,2.38s1.07,2.38,2.38,2.38 c1.31,0,2.38-1.07,2.38-2.38S417.16,433.25,415.84,433.25z"
  }))), /*#__PURE__*/React.createElement("g", null, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M435.34,435.63c0,2.05-1.67,3.72-3.72,3.72c-2.05,0-3.72-1.67-3.72-3.72c0-2.05,1.67-3.72,3.72-3.72 C433.68,431.91,435.34,433.57,435.34,435.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.563,
    y1: 435.626,
    x2: 436.6792,
    y2: 435.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M431.62,440.68c-2.79,0-5.06-2.27-5.06-5.06c0-2.79,2.27-5.06,5.06-5.06c2.79,0,5.06,2.27,5.06,5.06 C436.68,438.41,434.41,440.68,431.62,440.68z M431.62,433.25c-1.31,0-2.38,1.07-2.38,2.38s1.07,2.38,2.38,2.38 c1.31,0,2.38-1.07,2.38-2.38S432.93,433.25,431.62,433.25z"
  }))), /*#__PURE__*/React.createElement("g", null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M451.12,435.63c0,2.05-1.67,3.72-3.72,3.72c-2.05,0-3.72-1.67-3.72-3.72c0-2.05,1.67-3.72,3.72-3.72 C449.45,431.91,451.12,433.57,451.12,435.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3413,
    y1: 435.626,
    x2: 452.4585,
    y2: 435.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M447.4,440.68c-2.79,0-5.06-2.27-5.06-5.06c0-2.79,2.27-5.06,5.06-5.06c2.79,0,5.06,2.27,5.06,5.06 C452.46,438.41,450.19,440.68,447.4,440.68z M447.4,433.25c-1.31,0-2.38,1.07-2.38,2.38s1.07,2.38,2.38,2.38 c1.31,0,2.38-1.07,2.38-2.38S448.71,433.25,447.4,433.25z"
  }))), /*#__PURE__*/React.createElement("g", null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M466.9,435.63c0,2.05-1.67,3.72-3.72,3.72c-2.05,0-3.72-1.67-3.72-3.72c0-2.05,1.67-3.72,3.72-3.72 C465.23,431.91,466.9,433.57,466.9,435.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.1206,
    y1: 435.626,
    x2: 468.2378,
    y2: 435.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M463.18,440.68c-2.79,0-5.06-2.27-5.06-5.06c0-2.79,2.27-5.06,5.06-5.06c2.79,0,5.06,2.27,5.06,5.06 C468.24,438.41,465.97,440.68,463.18,440.68z M463.18,433.25c-1.31,0-2.38,1.07-2.38,2.38s1.07,2.38,2.38,2.38 c1.31,0,2.38-1.07,2.38-2.38S464.49,433.25,463.18,433.25z"
  }))), /*#__PURE__*/React.createElement("g", null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M482.68,435.63c0,2.05-1.67,3.72-3.72,3.72c-2.05,0-3.72-1.67-3.72-3.72c0-2.05,1.67-3.72,3.72-3.72 C481.01,431.91,482.68,433.57,482.68,435.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.8999,
    y1: 435.626,
    x2: 484.018,
    y2: 435.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M478.96,440.68c-2.79,0-5.06-2.27-5.06-5.06c0-2.79,2.27-5.06,5.06-5.06c2.79,0,5.06,2.27,5.06,5.06 C484.02,438.41,481.75,440.68,478.96,440.68z M478.96,433.25c-1.31,0-2.38,1.07-2.38,2.38s1.07,2.38,2.38,2.38 c1.31,0,2.38-1.07,2.38-2.38S480.27,433.25,478.96,433.25z"
  }))), /*#__PURE__*/React.createElement("g", null, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 538.25,
    y: 418.28,
    className: "st18",
    width: 31.54,
    height: 24.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 536.9536,
    y1: 430.7173,
    x2: 571.0952,
    y2: 430.7173
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M571.1,444.46h-34.14v-27.48h34.14V444.46z M539.55,441.85h28.94v-22.27h-28.94V441.85z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.7515,
    y1: 430.7174,
    x2: 563.2969,
    y2: 430.7174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M562.92,437.84l-5.14-5.25c1.94-2.77,1.7-6.61-0.75-9.12c-2.77-2.83-7.3-2.87-10.13-0.11 c-2.83,2.77-2.87,7.3-0.1,10.13c2.44,2.5,6.27,2.82,9.07,0.96l5.14,5.25c0.51,0.52,1.35,0.53,1.87,0.02l0.02-0.02 C563.42,439.2,563.43,438.36,562.92,437.84z M547.97,432.35c-2.13-2.17-2.09-5.67,0.08-7.8c2.17-2.13,5.67-2.09,7.8,0.08 c2.13,2.17,2.09,5.67-0.08,7.8C553.6,434.56,550.1,434.52,547.97,432.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.1567,
    y1: 304.9541,
    x2: 595.478,
    y2: 304.9541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M577.07,323.36h-19.51c-10.12,0-18.4-8.28-18.4-18.4l0,0c0-10.12,8.28-18.4,18.4-18.4h19.51 c10.12,0,18.4,8.28,18.4,18.4l0,0C595.48,315.08,587.2,323.36,577.07,323.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.7065,
    y1: 305.3062,
    x2: 578.8071,
    y2: 305.3062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "578.81,305.31 560.71,315.76 560.71,294.86  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.2065,
    y1: 305.3062,
    x2: 579.8071,
    y2: 305.3062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M560.21,316.62v-22.63l19.6,11.32L560.21,316.62z M561.21,295.72v19.17l16.6-9.58L561.21,295.72z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.707,
    y1: 437.4961,
    x2: 194.707,
    y2: 271.6758
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 138.09,
    y: 271.68,
    className: "st158",
    width: 113.24,
    height: 165.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.0854,
    y1: 354.5859,
    x2: 252.3286,
    y2: 354.5859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M252.33,438.5H137.09V270.68h115.24V438.5z M139.09,436.5h111.24V272.68H139.09V436.5z"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 139.11,
    y: 388.55,
    className: "st160",
    width: 111.19,
    height: 38.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.0854,
    y1: 287.6905,
    x2: 251.3286,
    y2: 287.6905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 138.09,
    y: 271.68,
    className: "st161",
    width: 113.24,
    height: 32.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.0854,
    y1: 287.6905,
    x2: 252.3286,
    y2: 287.6905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    style: {
      stopColor: "#024792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#039EC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M252.33,304.71H137.09v-34.03h115.24V304.71z M139.09,302.71h111.24v-30.03H139.09V302.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.2475,
    y1: 328.8311,
    x2: 172.1186,
    y2: 328.8311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st163",
    cx: 158.68,
    cy: 328.83,
    r: 13.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2475,
    y1: 328.8311,
    x2: 173.1186,
    y2: 328.8311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    style: {
      stopColor: "#024792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#039EC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M158.68,343.27c-7.96,0-14.44-6.48-14.44-14.44c0-7.96,6.48-14.44,14.44-14.44 c7.96,0,14.44,6.48,14.44,14.44C173.12,336.79,166.64,343.27,158.68,343.27z M158.68,316.4c-6.86,0-12.44,5.58-12.44,12.44 c0,6.86,5.58,12.44,12.44,12.44c6.86,0,12.44-5.58,12.44-12.44C171.12,321.97,165.54,316.4,158.68,316.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.2475,
    y1: 368.2628,
    x2: 172.1186,
    y2: 368.2628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st165",
    cx: 158.68,
    cy: 368.26,
    r: 13.44
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M158.68,382.7c-7.96,0-14.44-6.48-14.44-14.44c0-7.96,6.48-14.44,14.44-14.44 c7.96,0,14.44,6.48,14.44,14.44C173.12,376.22,166.64,382.7,158.68,382.7z M158.68,355.83c-6.86,0-12.44,5.58-12.44,12.44 s5.58,12.44,12.44,12.44c6.86,0,12.44-5.58,12.44-12.44S165.54,355.83,158.68,355.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.2475,
    y1: 407.6949,
    x2: 172.1186,
    y2: 407.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02247D"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M172.12,407.69c0,7.42-6.02,13.44-13.44,13.44c-7.42,0-13.44-6.01-13.44-13.44 c0-7.42,6.02-13.43,13.44-13.43C166.1,394.26,172.12,400.27,172.12,407.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.2475,
    y1: 407.6949,
    x2: 173.1186,
    y2: 407.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1925,
    style: {
      stopColor: "#024792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6157,
    style: {
      stopColor: "#039EC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M158.68,422.13c-7.96,0-14.44-6.48-14.44-14.43c0-7.96,6.48-14.44,14.44-14.44 c7.96,0,14.44,6.48,14.44,14.44C173.12,415.65,166.64,422.13,158.68,422.13z M158.68,395.26c-6.86,0-12.44,5.58-12.44,12.44 c0,6.86,5.58,12.43,12.44,12.43c6.86,0,12.44-5.58,12.44-12.43C171.12,400.84,165.54,395.26,158.68,395.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.9013,
    y1: 296.8106,
    x2: 236.5132,
    y2: 296.8106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 152.9,
    y: 294.9,
    className: "st168",
    width: 83.61,
    height: 3.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.4013,
    y1: 296.8106,
    x2: 237.0132,
    y2: 296.8106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M237.01,299.22H152.4v-4.82h84.61V299.22z M153.4,298.22h82.61v-2.82H153.4V298.22z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.69,
    y: 361.68,
    className: "st170",
    width: 57.24,
    height: 3.82
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 371.22,
    className: "st170",
    width: 38.16,
    height: 3.82
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.69,
    y: 322.15,
    className: "st170",
    width: 57.24,
    height: 3.82
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 331.69,
    className: "st170",
    width: 38.16,
    height: 3.82
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.69,
    y: 401.42,
    className: "st170",
    width: 57.24,
    height: 3.82
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.23,
    y: 410.96,
    className: "st170",
    width: 38.16,
    height: 3.82
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog2);
export default __webpack_public_path__ + "static/media/blog2.df7996bd4ef241fb6beedc4f39dd2196.svg";
export { ForwardRef as ReactComponent };